import React, {useState, useEffect} from 'react';
import { useDispatch  } from 'react-redux';
import { showModal, unselectAllRecord, toggleShowInEur } from '../actions';
import { useQuery } from '@apollo/react-hooks';
import { Grid } from 'react-awesome-spinners';
import {
  GlobalMessages,
  Table,
  TableHeadingWrap,
  Header,
  TableActionsWrap,
  TableAction   /* Release 3.2 - 7.1 - Ends */
} from "../components";

import { columns } from "../util/config";
import { InputField } from "../components/styled";
import { Redirect } from "react-router-dom";

import { GET_WORKFLOWS} from '../graphql';

import "./ResponsiveTable.css";

export default function WorkflowList(props) {
  
  const dispatch = useDispatch();
  const { account, messages, unselectAllRecord, toggleShowInEur, config} =
    props;
  const { loading, error, data } = useQuery(GET_WORKFLOWS);

  if (loading) return <>Loading...</>;
  if (error) return <>Error</>;

  const items = data?.workflowsList?.items ?? [];

  const workflowsById = Object.fromEntries(
    items.map(wf => [wf.WorkflowID, wf])
  );

  const getOrdinal = (num) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const value = num % 100;

    return num + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0]);
  };

  const getOperatorLabel = (op) => {
    const map = {
      "=": " Equals to ",
      "eq": " Equals ",
      "ne": " Not Equals to ",
      "ge": " Greater Than & Equals to ",
      "le": " Less Than & Equals To ",
      "gt": " Greater Than ",
      "lt": " Less Than ",
    };

    return (map[op?.toLowerCase()] || op).toUpperCase();
  };

  const handleTrackRequest = () => {
    dispatch(showModal({ component: 'trackrequestapprover' }));
  };

  return (
    <>
          <Header {...props} />
          
          <TableHeadingWrap>
            <h2>Workflow Management</h2>
            <TableActionsWrap>
              <TableAction width="200px" onClick={handleTrackRequest}>Track Request's Approvers Chain</TableAction>
            </TableActionsWrap>
          </TableHeadingWrap>
          <div className="table-wrapper">
            <table className="responsive-table">
              <thead>
                <tr>
                  <th>Applied For</th>
                  <th>Applied for [Country/Region]</th>
                  <th>Workflow Title</th>
                  <th>Specific Condition</th>
                  
                  <th>Requester Role(s)</th>
                  <th>Approver Role(s)</th>
                  <th>Condition(s) Applied</th>
                </tr>
              </thead>
              
              <tbody>
                {items.map(wf => {

                  var WorkflowTitle_ExtraStr = '';
                  const nameParts_Exp1 = wf.WorkflowName.split("-");
                  if(nameParts_Exp1.length == 1)
                  {
                    var WorkflowAppliedFor = nameParts_Exp1[0];
                    var WorkflowTitle = nameParts_Exp1[0];

                    const namePartsWithApprover_Exp1 = WorkflowTitle.split("$$$");
                    if(namePartsWithApprover_Exp1.length > 1)
                    {
                      WorkflowTitle = namePartsWithApprover_Exp1[0];
                      WorkflowTitle_ExtraStr = namePartsWithApprover_Exp1[1]

                    }

                    var WorkflowSpecificCondition = '';
                  }
                  else if(nameParts_Exp1.length == 2)
                  {
                    var WorkflowAppliedFor = nameParts_Exp1[0];
                    var WorkflowTitle = nameParts_Exp1[1];

                    const namePartsWithApprover_Exp1 = WorkflowTitle.split("$$$");
                    if(namePartsWithApprover_Exp1.length > 1)
                    {
                      WorkflowTitle = namePartsWithApprover_Exp1[0];
                      WorkflowTitle_ExtraStr = namePartsWithApprover_Exp1[1]

                    }
                    var WorkflowSpecificCondition = '';
                  }
                  else
                  {
                    var WorkflowAppliedFor = nameParts_Exp1[0];
                    var WorkflowTitle = nameParts_Exp1[2];

                    const namePartsWithApprover_Exp1 = WorkflowTitle.split("$$$");
                    if(namePartsWithApprover_Exp1.length > 1)
                    {
                      WorkflowTitle = namePartsWithApprover_Exp1[0];
                      WorkflowTitle_ExtraStr = namePartsWithApprover_Exp1[1]

                    }

                    var WorkflowSpecificCondition = nameParts_Exp1[1];
                  }
                  WorkflowAppliedFor = WorkflowAppliedFor.replace("[", "");
                  WorkflowAppliedFor = WorkflowAppliedFor.replace("]", "");

                  return (   // ✅ ADD THIS
                    <tr>
                      <td>{WorkflowAppliedFor}</td>
                      <td>{wf.WorkflowCountryRegion}</td>
                      <td style={{ width: "20%" }}>{WorkflowTitle}
                        {<b style={{ width: "100%", float: "left" }}>{WorkflowTitle_ExtraStr}</b>}
                      </td>
                      <td style={{ width: "10%" }}>{WorkflowSpecificCondition}</td>
                      

                      <td>
                        <ul style={{ margin: "0", padding: "0" }}>
                          {wf.requesterRoles.map(role => (
                            <li key={role.pkWorkflowRequesterRoleMapID}>
                              {role.WorkflowRequesterRoleTitle}
                            </li>
                          ))}
                        </ul>
                      </td>

                      <td>
                        {wf.approverRoles.map((item, index) => (
                          <div style={{ margin: "0", padding: "0" }} key={item.pkWorkflowApproverRoleMapID}>
                            <b>{getOrdinal(index + 1)}: </b>
                            {item.WorkflowApproverRoleTitle}
                          </div>
                        ))}
                      </td>

                      <td>
                        <ul style={{ margin: "0", padding: "0" }}>
                          {wf.workflowConditions.map(conds => (
                            <li key={conds.pkWorkflowConditionMapID}>
                              <b>{conds.WorkflowConditionType}</b> 

                              <span style={{ backgroundColor:"yellow" }}>
                                {getOperatorLabel(conds.WorkflowConditionOperator)}
                              </span> 

                              {conds.WorkflowConditionValue}
                            </li>
                          ))}
                        </ul>
                      </td>

                    </tr>
                  );   // ✅ AND CLOSE IT
                })}
              </tbody>
            </table>
          </div>
          
          </>
  );
}